import { anyRarity } from './content.js';
import { KASSIM, MERET, NEFER, SMITH } from './desert-chain-1.js';
const JARL = { mob: 'jarl', biome: 'snow' };
/**
 * The desert's chain, second half: the Forgotten Pharaoh's stolen mask, the
 * Jackal's Temple and its golden guardian, then the caravan road north to
 * Givrecime.
 */
export const DESERT_CHAIN_END = [
    {
        id: 'desert-glyphs',
        name: 'Les glyphes effacés',
        biome: 'desert',
        level: 14,
        requires: ['desert-obelisk'],
        giver: NEFER,
        turnIn: NEFER,
        offer: 'Le nom du roi est gravé sur l’Obélisque, mais le sable a rempli les lettres. Et les momies me chassent dès que j’approche ! Chasse-les, et rapporte-moi du sable de verre : en frottant, je pourrai lire les lettres.',
        summary: 'Abattre des momies autour de l’Obélisque Oublié et rapporter du sable de verre à Néfer.',
        pending: 'Chasse d’abord les momies, puis rapporte-moi du sable de verre. Les bêtes du désert en ont.',
        complete: 'Regarde, les lettres réapparaissent ! Ounas-Rê. Le Pharaon oublié ! Ses propres prêtres l’ont maudit et enterré sans nom. Ils ont caché son masque en or très loin de lui, pour qu’il ne puisse jamais revenir.',
        objectives: [
            { kind: 'kill', label: 'Momies écartées', mobs: ['mummy'], count: 15 },
            { kind: 'collect', label: 'Sable de verre', item: 'glass-sand', count: 2 },
        ],
        reward: { xp: 1100, gold: 220 },
    },
    {
        id: 'desert-mask',
        name: 'Le masque volé',
        biome: 'desert',
        level: 14,
        requires: ['desert-glyphs'],
        giver: NEFER,
        turnIn: KASSIM,
        offer: 'Un masque en or caché loin de son maître, des momies qui fouillent une caravane… Va demander à Kassim ce qu’il transportait exactement. Et regarde bien sa tête quand il répondra.',
        summary: 'Retourner à Sablerouge et demander à Kassim ce que transportait sa caravane.',
        pending: 'Tu reviens de chez Néfer ? Alors, qu’est-ce qu’elle a dit ? Et combien elle va me faire payer, cette fois ?',
        complete: 'Ounas-Rê… Bon. D’accord. Je l’avoue : j’ai acheté un masque en or à des pilleurs de tombes, au printemps. Je voulais le revendre trois fois plus cher dans le nord. Je ne savais pas ! Enfin, je ne voulais pas savoir. Par tous les puits du désert, qu’est-ce que j’ai fait ?',
        objectives: [{ kind: 'reach', label: 'Retourner à Sablerouge', landmark: 'Sablerouge' }],
        reward: { xp: 400, gold: 80 },
    },
    {
        id: 'desert-camp',
        name: 'Les pilleurs de tombes',
        biome: 'desert',
        level: 14,
        requires: ['desert-mask'],
        giver: KASSIM,
        turnIn: KASSIM,
        offer: 'Les pilleurs qui m’ont vendu le masque se sont enfuis dans les dunes avec mon or, et les monstres les ont attrapés. Leur butin est dans un coffre, gardé par des bêtes. Ouvre-le ! Il y a peut-être une carte de la tombe. Et si tu trouves mon or, c’est le mien, hein.',
        summary: 'Vaincre les gardiens d’un camp du désert et ouvrir son coffre.',
        pending: 'Bats tous les gardiens, sinon le coffre reste fermé. Et moi, je reste ruiné.',
        complete: 'Pas d’or, pas de carte… mais un dessin ! Une montagne toute pointue. C’est l’Aiguille de Braise ! De là-haut, on voit tout le désert.',
        objectives: [{ kind: 'camp', label: 'Coffre d’un camp du désert', biome: 'desert', count: 1 }],
        reward: { xp: 1100, gold: 220, items: [{ templateId: 'glass-sand', quantity: 2 }] },
    },
    {
        id: 'desert-summit',
        name: 'Le guet de l’Aiguille',
        biome: 'desert',
        level: 15,
        requires: ['desert-camp'],
        giver: KASSIM,
        turnIn: NEFER,
        offer: 'L’Aiguille de Braise est au sud-ouest de la ville. Une grotte à son pied monte jusqu’au sommet. Grimpe, regarde où vont les momies, puis va le dire à Néfer. Moi, je n’ose plus aller la voir.',
        summary: 'Monter au sommet de l’Aiguille de Braise par sa grotte, puis rapporter ce qu’on y voit à Néfer.',
        pending: 'Entre dans la grotte au pied de l’Aiguille et monte jusqu’en haut. Regarde vers l’ouest.',
        complete: 'Les momies marchent en file vers l’ouest ? Elles rapportent le masque à leur maître… ici, juste sous mes pieds ! S’il remet son masque, tous les morts du désert vont se réveiller. Et il y en a beaucoup.',
        objectives: [
            { kind: 'reach', label: 'Atteindre le sommet de l’Aiguille', landmark: 'Aiguille de Braise' },
        ],
        reward: { xp: 700, gold: 140, items: [{ templateId: 'desert-potion', quantity: 2 }] },
    },
    {
        id: 'desert-cursed',
        name: 'La Momie maudite',
        biome: 'desert',
        level: 15,
        requires: ['desert-summit'],
        giver: NEFER,
        turnIn: NEFER,
        offer: 'Les momies ont un chef : l’ancien grand prêtre du pharaon. Il change de tombe tout le temps, mais il ne résiste pas à l’encens des enterrements. Fais brûler cet encens près d’un repaire de momies, et il viendra.',
        summary: 'Brûler l’encens funéraire près d’un repaire de momies, puis abattre la Momie maudite qui en sort.',
        pending: 'Fais brûler l’encens près d’un repaire de momies, loin du village. S’il ne vient pas, recommence. Et ne respire pas la fumée !',
        complete: 'Il est retombé en poussière ! Il portait ce Némès sous ses bandages, celui des gardes du pharaon. Il est bien plus solide que celui du marchand. Et c’est un vrai, lui.',
        grants: [{ templateId: 'funeral-incense', quantity: 1 }],
        objectives: [
            { kind: 'kill', label: 'Momie maudite abattue', mobs: ['cursed-mummy'], count: 1 },
        ],
        reward: { xp: 1200, gold: 240, items: [{ templateId: 'pharaoh-helm-rare', quantity: 1 }] },
    },
    {
        id: 'desert-mummies',
        name: 'La procession des morts',
        biome: 'desert',
        level: 15,
        requires: ['desert-summit'],
        giver: NEFER,
        turnIn: NEFER,
        offer: 'Même sans leur prêtre, les momies continuent de marcher. Chaque momie que tu bats ralentit le cortège qui porte le masque. Bats-en le plus possible, de l’Obélisque jusqu’à Sablerouge. Je compte !',
        summary: 'Abattre les momies de la procession, partout dans le désert.',
        pending: 'Continue, le cortège ralentit ! Je le vois d’ici.',
        complete: 'Le cortège s’est arrêté ! Je ne sais pas pour combien de temps, mais on a gagné un peu de répit.',
        objectives: [{ kind: 'kill', label: 'Momies de la procession', mobs: ['mummy'], count: 25 }],
        reward: { xp: 1300, gold: 260 },
    },
    {
        id: 'desert-salamanders',
        name: 'Écailles de braise',
        biome: 'desert',
        level: 15,
        requires: ['desert-summit'],
        giver: SMITH,
        turnIn: SMITH,
        offer: 'Kassim m’a tout raconté, il ne sait pas tenir sa langue quand il a peur. Contre un roi mort, il faut une arme très spéciale. Les salamandres de braise ont des écailles brûlantes, parfaites pour ça. Rapporte-m’en, mais ne les touche pas à mains nues !',
        summary: 'Abattre des salamandres de braise et rapporter leurs écailles au forgeron de Sablerouge.',
        pending: 'Les salamandres courent plus vite que toi, alors ne fuis pas. Frappe la première !',
        complete: 'Elles brûlent encore ! Aïe aïe aïe. Oui, je sais, je t’avais prévenu. Voilà deux scarabées d’or. Avec ça, je peux monter ton équipement au-delà de cinq crans.',
        objectives: [
            {
                kind: 'kill',
                label: 'Salamandres de braise abattues',
                mobs: ['ember-salamander'],
                count: 15,
            },
            { kind: 'collect', label: 'Écailles de braise', item: 'ember-scale', count: 5 },
        ],
        reward: { xp: 1200, gold: 240, items: [{ templateId: 'gold-scarab', quantity: 2 }] },
    },
    {
        id: 'desert-temper',
        name: 'Une lame pour un roi',
        biome: 'desert',
        level: 15,
        requires: ['desert-salamanders'],
        giver: SMITH,
        turnIn: SMITH,
        offer: 'Maintenant, il te faut le Khépesh du pharaon, l’épée de ses propres gardes. Le marchand en vend un. Et fais monter une pièce à cinq crans. D’après Néfer, un roi mort n’a peur que de sa propre épée. Moi, je ne sais pas lire, alors je la crois.',
        summary: 'Porter un Khépesh du pharaon et une pièce d’équipement à +5.',
        pending: 'Le Khépesh est chez le marchand. Pour le cinquième cran, il faut du sable de verre et un peu de chance. Surtout de la chance.',
        complete: 'Ça, c’est une arme ! Prends ces potions, je ne les boirai pas. Et va régler son compte au pharaon !',
        objectives: [
            { kind: 'wear', label: 'Porter un Khépesh du pharaon', items: anyRarity('pharaoh-sword') },
            { kind: 'upgrade', label: 'Une pièce portée à +5', level: 5 },
        ],
        reward: { xp: 900, gold: 180, items: [{ templateId: 'desert-tonic', quantity: 4 }] },
    },
    {
        id: 'desert-pharaoh',
        name: 'Le Pharaon oublié',
        biome: 'desert',
        level: 15,
        requires: ['desert-cursed', 'desert-mummies', 'desert-temper'],
        giver: NEFER,
        turnIn: NEFER,
        offer: 'Trop tard, il a retrouvé son masque ! Il se promène d’une tombe à l’autre, et toutes les momies le suivent. J’ai gravé son nom sur ce cartouche cette nuit. Pose-le près d’un repaire de momies : un roi vient toujours quand on écrit son nom. Arrache-lui ce masque !',
        summary: 'Poser le cartouche royal près d’un repaire de momies et abattre le Pharaon oublié.',
        pending: 'Pose le cartouche près d’un repaire de momies. Et emporte des potions, je ne le répéterai pas.',
        complete: 'Le masque ! Il est froid, maintenant. Ounas-Rê dort enfin. Prends son sceptre, il n’en aura plus besoin. Mais ce masque avait un gardien… et lui, il ne dort pas.',
        grants: [{ templateId: 'royal-cartouche', quantity: 1 }],
        objectives: [
            { kind: 'kill', label: 'Pharaon oublié abattu', mobs: ['forgotten-pharaoh'], count: 1 },
        ],
        reward: { xp: 1800, gold: 360, items: [{ templateId: 'ounas-re-sceptre', quantity: 1 }] },
    },
    {
        id: 'desert-temple',
        name: 'Le Temple du Chacal',
        biome: 'desert',
        level: 15,
        requires: ['desert-pharaoh'],
        giver: NEFER,
        turnIn: MERET,
        offer: 'Ce masque appartient au Temple du Chacal, à l’est de la ville. Méret, la dernière prêtresse, garde toujours l’entrée, toute seule. Va lui raconter ce qui s’est passé. Elle sait ce qui se cache sous le temple. Moi, je préfère ne pas savoir.',
        summary: 'Rejoindre le Temple du Chacal, à l’est de Sablerouge, et parler à la prêtresse Méret.',
        pending: 'Le temple est à l’est, au bout du chemin bordé de braseros. Ils sont éteints, tu verras.',
        complete: 'Le masque est revenu ? Alors tu as battu le pharaon ! Bravo. Mais assieds-toi, il y a un problème : son gardien, le Chacal d’Or, s’est réveillé en même temps que lui. Je l’entends gratter sous le sol depuis la nuit où les braseros se sont éteints.',
        objectives: [
            { kind: 'reach', label: 'Atteindre le Temple du Chacal', landmark: 'Temple du Chacal' },
        ],
        reward: { xp: 500, gold: 100 },
    },
    {
        id: 'desert-oaths',
        name: 'Les serments de Méret',
        biome: 'desert',
        level: 15,
        requires: ['desert-temple'],
        giver: MERET,
        turnIn: MERET,
        offer: 'Les salamandres et les scorpions du temple gardaient nos braseros. Mais depuis que le Chacal d’Or s’est réveillé, ils attaquent les visiteurs ! Chasse-les, que je puisse rallumer les feux.',
        summary: 'Abattre les salamandres de braise et les scorpions géants devenus fous.',
        pending: 'Tant que les bêtes rôdent, je ne peux pas rallumer les braseros.',
        complete: 'Les braseros brûlent à nouveau, merci ! Mes ancêtres avaient juré qu’ils ne s’éteindraient jamais. Ils se sont éteints pour la première fois en sept cents ans… et c’était pendant mon tour de garde. La honte. J’ai d’autres secrets à te dire, mais d’abord, le Chacal.',
        objectives: [
            {
                kind: 'kill',
                label: 'Salamandres de braise abattues',
                mobs: ['ember-salamander'],
                count: 12,
            },
            { kind: 'kill', label: 'Scorpions géants abattus', mobs: ['scorpion'], count: 12 },
        ],
        reward: { xp: 1400, gold: 280, items: [{ templateId: 'desert-potion', quantity: 3 }] },
    },
    {
        id: 'desert-jackal',
        name: 'Le Chacal d’Or',
        biome: 'desert',
        level: 16,
        requires: ['desert-oaths'],
        giver: MERET,
        turnIn: KASSIM,
        offer: 'Le Chacal d’Or se cache sous le temple. Il gardait le masque depuis si longtemps que l’or lui a fait perdre la tête. Descends le battre, emmène des amis et ta meilleure arme. Ensuite, va dire à Kassim que sa dette est payée. Il comprendra.',
        summary: 'Abattre le Chacal d’Or au fond de son temple, puis prévenir Kassim.',
        pending: 'Méret t’a ouvert le temple ? Alors vas-y, bats le Chacal ! Et ne me raconte rien tant que ce n’est pas fini, je suis trop stressé.',
        complete: 'Le Chacal d’Or est battu ! Et ma dette avec. Prends ce pectoral, il était à mon grand-père. Et mon grand-père n’a jamais rien donné à personne, alors c’est un honneur ! Ah, et Méret te demande au temple. Elle a parlé d’une plaine de verre, et elle avait l’air inquiète.',
        objectives: [{ kind: 'kill', label: 'Chacal d’Or abattu', mobs: ['golden-jackal'], count: 1 }],
        reward: { xp: 2500, gold: 500, items: [{ templateId: 'pharaoh-chest-rare', quantity: 1 }] },
    },
    {
        id: 'desert-north',
        name: 'La route du nord',
        biome: 'desert',
        level: 16,
        requires: ['desert-recruit'],
        giver: KASSIM,
        turnIn: JARL,
        offer: 'Méret est partie avec ton chevalier. Elle dit que la chaîne du dragon s’affaiblit, et qu’il faut prévenir le nord. Ma première caravane depuis toute cette histoire part pour Givrecime, au-delà de la capitale. Pars devant, et dis au Jarl que Kassim lui envoie ce qu’il a de mieux. Et que ce n’est pas à vendre !',
        summary: 'Remonter vers le nord jusqu’à Givrecime et parler au Jarl.',
        pending: 'Givrecime est tout au nord, dans les Pics Gelés. Là-haut, il neige même en été. Moi non plus, je n’y crois pas.',
        complete: 'C’est Kassim qui t’envoie ? Ce vieux renard me doit une peau d’ours depuis dix ans, et il m’envoie quelqu’un à la place ! Ha ! Entre vite, secoue la neige de tes bottes, il fait bon dans la halle.',
        objectives: [{ kind: 'reach', label: 'Atteindre Givrecime', landmark: 'Givrecime' }],
        reward: { xp: 600, gold: 120 },
    },
];
//# sourceMappingURL=desert-chain-2.js.map